// Карта «Рядом с домом» (/tutors) — тексты на трёх языках.
// Заголовок «Рядом с домом» — из design/reference/Tutors.dc.html. Остальное —
// новые подписи, ЖДУТ УТВЕРЖДЕНИЯ владельца (список в теле PR). AZ — на вычитку.
// Названия предметов, районов, форматов, классов — из map-taxonomy.json.
// Чего здесь нет намеренно: рейтингов, отзывов, значка «Проверен», «Подходит
// профилю» — этого в продукте пока нет (решение владельца 06.10.2026).
import type { SiteLang } from "@/components/site/SiteChrome";

export const TUTORS_PATH: Record<SiteLang, string> = { ru: "/ru/tutors", az: "/az/tutors", en: "/en/tutors" };

type Copy = {
  meta: { title: string; description: string };
  title: string;
  /** H1 хаба /tutors (16.10.2026). title выше — название карты («Evə yaxın»), им подписаны кнопки. */
  h1: string;
  /** Интро хаба (~120 слов, рисуется сервером): только то, что карта действительно умеет. */
  intro: string[];
  introTest: string;
  introJoin: string;
  /** Плашка для репетиторов вверху хаба (19.10.2026): текст и кнопка. */
  joinBannerText: string;
  joinBannerBtn: string;
  /** Блок ссылок на страницы предметов (у кого ≥ 3 анкет). */
  subjectPagesTitle: string;
  /** Страница предмета: ссылка на карту с этим предметом и «соседние предметы». */
  subjectOnMap: string;
  subjectNeighbours: string;
  breadcrumbHub: string;
  lead: string;
  layerTutors: string;
  layerClubs: string;
  tabNear: string;
  tabOnline: string;
  subjectAll: string;
  directionAll: string;
  districtAll: string;
  /** Фильтр «Город»: Баку и города, где есть опубликованные анкеты (src/lib/map-cities.ts). */
  city: string;
  /** Вариант фильтра «Город»: анкеты всех городов. */
  cityAll: string;
  formatAll: string;
  gradeAll: string;
  agePh: string;
  priceMaxPh: string;
  /** Фильтр по цене урока: анкеты, где цену урока посчитать нельзя, — под этой подписью в конце. */
  priceUnknown: string;
  trialOnly: string;
  reset: string;
  count: (n: number) => string;
  showMap: string;
  /** «Моё местоположение» (решение владельца 12.10). */
  me: {
    button: string;
    locating: string;
    youAreHere: string;
    home: string;
    remove: string;
    sorted: string;
    addressPh: string;
    pinOnMap: string;
    pinHint: string;
    denied: string;
    /** Кнопка в сообщении об отказе/сбое: показать поле адреса и поставить в него курсор. */
    typeAddress: string;
    failed: string;
    lowAccuracy: (km: string) => string;
    noMaps: string;
  };
  showList: string;
  perLesson: string;
  perMonth: string;
  nearMetro: string;
  travelsTo: string;
  /** Фильтр «Придёт к нам домой»: первая строка списка районов. */
  comesHomeAll: string;
  /** Карточка building с районами выезда: «Также приезжает к ученику: …». */
  alsoTravelsTo: string;
  online: string;
  /** Подпись ориентира в профиле (20261031120000). */
  landmark: string;
  years: string;
  call: string;
  whatsapp: string;
  phoneError: string;
  more: string;
  trialFree: string;
  emptyTitle: string;
  notFoundTitle: string;
  reqLead: string;
  reqSubject: string;
  reqGrade: string;
  reqAge: string;
  reqDistrict: string;
  reqBudget: string;
  reqPhone: string;
  reqSend: string;
  reqSending: string;
  reqSent: string;
  reqError: string;
  /** Подбор репетиторов (20261103120000). */
  reqLeadTutor: string;
  reqEmail: string;
  /** Подпись пары полей (04.11.2026): нужен телефон ИЛИ почта. */
  reqContactTitle: string;
  /** Нет ни телефона, ни почты с согласием — по нажатию «Отправить». */
  reqContactNeeded: string;
  reqConsent: string;
  reqFormat: string;
  reqFormatAny: string;
  reqFormatTutor: string;
  reqFormatHome: string;
  reqFormatOnline: string;
  reqOnlineOk: string;
  reqPerLesson: string;
  reqPerMonth: string;
  reqTeachLang: string;
  reqComment: string;
  /** {email} заменяется адресом. */
  reqSentTo: string;
  reqSentNoEmail: string;
  reqMatchedTitle: string;
  reqNoMatch: string;
  reqRateLimited: string;
  loadError: string;
  joinCta: string;
  backToMap: string;
  notFound: string;
  separate: string;
  /** Строка под картой: кого на карте нет и где их искать. */
  mapOffNote: string;
  /** Подпись крестика окошка и шторки. */
  closeCard: string;
  /** Профиль /tutors/<slug>: блок описания, свернуть/развернуть, фото, мини-карта. */
  aboutTitle: string;
  aboutMore: string;
  aboutLess: string;
  links: string;
  photoOpen: string;
  photoClose: string;
  openOnMap: string;
};

export const MAP_COPY: Record<SiteLang, Copy> = {
  ru: {
    meta: {
      title: "Репетиторы и кружки в Азербайджане — Yolutap",
      description: "Карта репетиторов и кружков Азербайджана: предмет, район, класс, цена. Бесплатно для семей.",
    },
    title: "Рядом с домом",
    h1: "Репетиторы и кружки в Азербайджане",
    intro: [
      "На карте Yolutap — репетиторы и кружки Азербайджана. Выберите предмет, район, класс, формат и цену урока: карта и список покажут только подходящие анкеты. Тех, кто ведёт уроки онлайн, ищите во вкладке «Онлайн». Репетиторы и кружки — два слоя карты, между ними переключатель над фильтрами. Нужен тот, кто сам приедет к ребёнку? Выберите свой район в фильтре «Придёт к нам домой».",
      "Для семей карта бесплатна. С репетитором или кружком вы связываетесь напрямую: номер телефона открывается по кнопке «Позвонить». У каждой анкеты своя страница — с предметами, классами, ценой, местом занятий и контактами.",
      "Не знаете, что ребёнку стоит подтянуть? Сначала пройдите тест Yolutap: отчёт покажет, на какие предметы и направления опереться. Вы репетитор или ведёте кружок? Регистрация на карте бесплатна.",
    ],
    introTest: "Пройти тест",
    introJoin: "Добавить себя на карту",
    joinBannerText: "Вы репетитор или ведёте кружок? Добавьте себя на карту — бесплатно",
    joinBannerBtn: "Добавить себя на карту",
    subjectPagesTitle: "Репетиторы по предметам",
    subjectOnMap: "Открыть на карте",
    subjectNeighbours: "Другие предметы",
    breadcrumbHub: "Репетиторы и кружки",
    lead: "Репетиторы и кружки Азербайджана на одной карте",
    layerTutors: "Репетиторы",
    layerClubs: "Кружки",
    tabNear: "Рядом",
    tabOnline: "Онлайн",
    subjectAll: "Все предметы",
    directionAll: "Все направления",
    districtAll: "Все районы",
    city: "Город",
    cityAll: "Все города",
    formatAll: "Любой формат",
    gradeAll: "Любой класс",
    agePh: "Возраст ребёнка",
    priceMaxPh: "Цена урока до, ₼",
    priceUnknown: "Цена урока не указана — эти анкеты фильтр по цене не проверяет",
    trialOnly: "Первое занятие бесплатно",
    reset: "Сбросить",
    count: (n) => `Найдено: ${n}`,
    showMap: "Карта",
    me: {
      button: "Моё местоположение",
      locating: "Определяем…",
      youAreHere: "Вы здесь",
      home: "Мой дом",
      remove: "Удалить",
      sorted: "Сначала ближайшие",
      addressPh: "Адрес или метро",
      pinOnMap: "Отметить на карте",
      pinHint: "Нажмите на карту — поставим метку «Мой дом». Её можно перетащить.",
      denied: "Доступ к местоположению не разрешён. Введите адрес или метро, или отметьте дом на карте.",
      typeAddress: "Ввести адрес",
      failed: "Не получилось определить местоположение. Введите адрес или метро, или отметьте дом на карте.",
      lowAccuracy: (km) => `Местоположение определилось неточно (около ${km}). Введите адрес или метро, или отметьте дом на карте.`,
      noMaps: "Карта сейчас недоступна — выберите район в фильтре.",
    },
    showList: "Список",
    perLesson: "за урок",
    perMonth: "в месяц",
    nearMetro: "у метро",
    travelsTo: "Выезд",
    comesHomeAll: "Придёт к нам домой",
    alsoTravelsTo: "Также приезжает к ученику",
    online: "Онлайн",
    landmark: "Ориентир",
    years: "лет",
    call: "Позвонить",
    whatsapp: "WhatsApp",
    phoneError: "Не удалось получить номер. Попробуйте ещё раз.",
    more: "Подробнее",
    trialFree: "Первое занятие бесплатно",
    emptyTitle: "В этом районе пока никого — оставьте заявку, подберём",
    notFoundTitle: "Не нашли рядом? Оставьте заявку",
    reqLead: "Напишите, кого ищете, — мы подберём и перезвоним.",
    reqSubject: "Предмет или направление",
    reqGrade: "Класс",
    reqAge: "Возраст ребёнка",
    reqDistrict: "Район",
    reqBudget: "Бюджет, ₼",
    reqPhone: "Телефон (WhatsApp)",
    reqSend: "Оставить заявку",
    reqSending: "Отправляем…",
    reqSent: "Заявка отправлена. Мы свяжемся с вами.",
    reqError: "Не удалось отправить. Попробуйте ещё раз или напишите на support@yolutap.com.",
    reqLeadTutor: "Расскажите, кого ищете, — подберём 3–5 репетиторов и пришлём на почту за минуту.",
    reqEmail: "Почта (пришлём подборку)",
    reqContactTitle: "Телефон (WhatsApp) или почта",
    reqContactNeeded: "Укажите телефон (WhatsApp) или почту — туда пришлём подборку",
    reqConsent: "Согласен(на) получить подборку репетиторов на эту почту",
    reqFormat: "Где заниматься",
    reqFormatAny: "Не важно",
    reqFormatTutor: "У репетитора",
    reqFormatHome: "У нас дома",
    reqFormatOnline: "Онлайн",
    reqOnlineOk: "Онлайн тоже подходит",
    reqPerLesson: "за урок",
    reqPerMonth: "в месяц",
    reqTeachLang: "Язык обучения",
    reqComment: "Комментарий",
    reqSentTo: "Подборку отправили на {email}.",
    reqSentNoEmail: "Заявка отправлена. Подходящие репетиторы — ниже.",
    reqMatchedTitle: "Подходящие репетиторы",
    reqNoMatch: "Подходящего репетитора пока нет — подберём вручную и свяжемся с вами в течение дня.",
    reqRateLimited: "Слишком много заявок с этого номера за сутки. Напишите нам на hello@yolutap.com.",
    loadError: "Не удалось загрузить карту. Обновите страницу.",
    joinCta: "Вы репетитор или кружок? Разместитесь бесплатно",
    backToMap: "← К карте",
    notFound: "Анкета не найдена или снята с карты.",
    separate: "Рекомендации карьерных отчётов Yolutap не зависят от того, кто размещён на карте.",
    mapOffNote: "Онлайн-репетиторов и тех, кто приезжает домой, на карте нет — смотрите вкладку «Онлайн» и фильтр «Придёт к нам домой».",
    closeCard: "Закрыть",
    aboutTitle: "О себе",
    aboutMore: "Ещё",
    aboutLess: "Свернуть",
    links: "Ссылки",
    photoOpen: "Открыть фото",
    photoClose: "Закрыть",
    openOnMap: "Открыть на карте",
  },
  az: {
    meta: {
      title: "Azərbaycanda repetitorlar və dərnəklər — Yolutap",
      description: "Azərbaycanın repetitor və dərnəklərinin xəritəsi: fənn, rayon, sinif, qiymət. Ailələr üçün pulsuz.",
    },
    title: "Evə yaxın",
    h1: "Azərbaycanda repetitorlar və dərnəklər",
    intro: [
      "Yolutap xəritəsində Azərbaycanın repetitorları və dərnəkləri bir yerdədir. Fənni, rayonu, sinfi, formatı və dərs qiymətini seçin — xəritə və siyahı yalnız uyğun anketləri göstərəcək. Onlayn dərs keçənlər «Onlayn» bölməsindədir. Repetitorlar və dərnəklər xəritənin iki ayrı qatıdır — aralarında filtrlərin üstündəki düymə ilə keçirsiniz. Uşağın yanına özü gələn repetitor lazımdır? «Evimizə gəlsin» filtrində rayonunuzu seçin.",
      "Ailələr üçün xəritə pulsuzdur. Repetitor və ya dərnəklə birbaşa əlaqə saxlayırsınız: telefon nömrəsi «Zəng et» düyməsini basanda görünür. Hər anketin öz səhifəsi var — fənlər, siniflər, qiymət, dərslərin keçdiyi yer və əlaqə vasitələri ilə.",
      "Uşağın nəyi gücləndirməli olduğunu bilmirsiniz? Əvvəlcə Yolutap testindən keçin: hesabat hansı fənlərə və istiqamətlərə söykənməyi göstərəcək. Repetitorsunuz və ya dərnək aparırsınız? Xəritədə qeydiyyat pulsuzdur.",
    ],
    introTest: "Testdən keç",
    introJoin: "Xəritəyə əlavə ol",
    joinBannerText: "Repetitorsunuz və ya dərnək aparırsınız? Özünüzü xəritəyə əlavə edin — pulsuz",
    joinBannerBtn: "Xəritəyə əlavə ol",
    subjectPagesTitle: "Fənlər üzrə repetitorlar",
    subjectOnMap: "Xəritədə aç",
    subjectNeighbours: "Digər fənlər",
    breadcrumbHub: "Repetitorlar və dərnəklər",
    lead: "Azərbaycanın repetitor və dərnəkləri bir xəritədə",
    layerTutors: "Repetitorlar",
    layerClubs: "Dərnəklər",
    tabNear: "Yaxında",
    tabOnline: "Onlayn",
    subjectAll: "Bütün fənlər",
    directionAll: "Bütün istiqamətlər",
    districtAll: "Bütün rayonlar",
    city: "Şəhər",
    cityAll: "Hamısı",
    formatAll: "İstənilən format",
    gradeAll: "İstənilən sinif",
    agePh: "Uşağın yaşı",
    priceMaxPh: "Dərsin qiyməti, ₼-dək",
    priceUnknown: "Dərs qiyməti göstərilməyib — bu anketləri qiymət filtri yoxlamır",
    trialOnly: "İlk dərs pulsuzdur",
    reset: "Sıfırla",
    count: (n) => `Tapıldı: ${n}`,
    showMap: "Xəritə",
    me: {
      button: "Mənim yerim",
      locating: "Təyin edirik…",
      youAreHere: "Siz buradasınız",
      home: "Evim",
      remove: "Sil",
      sorted: "Əvvəlcə ən yaxınlar",
      addressPh: "Ünvan və ya metro",
      pinOnMap: "Xəritədə qeyd et",
      pinHint: "Xəritəyə toxunun — «Evim» işarəsini qoyaq. Onu sürüşdürmək olar.",
      denied: "Yerinizə icazə verilmədi. Ünvanı və ya metronu yazın, ya da evinizi xəritədə qeyd edin.",
      typeAddress: "Ünvanı yaz",
      failed: "Yerinizi təyin etmək alınmadı. Ünvanı və ya metronu yazın, ya da evinizi xəritədə qeyd edin.",
      lowAccuracy: (km) => `Yeriniz dəqiq təyin olunmadı (təxminən ${km}). Ünvanı və ya metronu yazın, ya da evinizi xəritədə qeyd edin.`,
      noMaps: "Xəritə hazırda açılmır — filtrdə rayonu seçin.",
    },
    showList: "Siyahı",
    perLesson: "dərs üçün",
    perMonth: "aylıq",
    nearMetro: "metro",
    travelsTo: "Gediş",
    comesHomeAll: "Evimizə gəlsin",
    alsoTravelsTo: "Şagirdin yanına da gedir",
    online: "Onlayn",
    landmark: "Oriyentir",
    years: "yaş",
    call: "Zəng et",
    whatsapp: "WhatsApp",
    phoneError: "Nömrəni almaq alınmadı. Yenidən cəhd edin.",
    more: "Ətraflı",
    trialFree: "İlk dərs pulsuzdur",
    emptyTitle: "Bu rayonda hələ heç kim yoxdur — müraciət qoyun, seçək",
    notFoundTitle: "Yaxında tapmadınız? Müraciət qoyun",
    reqLead: "Kimi axtardığınızı yazın — seçib sizə zəng edəcəyik.",
    reqSubject: "Fənn və ya istiqamət",
    reqGrade: "Sinif",
    reqAge: "Uşağın yaşı",
    reqDistrict: "Rayon",
    reqBudget: "Büdcə, ₼",
    reqPhone: "Telefon (WhatsApp)",
    reqSend: "Müraciət qoy",
    reqSending: "Göndərilir…",
    reqSent: "Müraciət göndərildi. Sizinlə əlaqə saxlayacağıq.",
    reqError: "Göndərmək alınmadı. Yenidən cəhd edin və ya support@yolutap.com ünvanına yazın.",
    reqLeadTutor: "Kimi axtardığınızı yazın — 3–5 repetitor seçib bir dəqiqəyə e-poçtunuza göndərəcəyik.",
    reqEmail: "E-poçt (seçimi göndərəcəyik)",
    reqContactTitle: "Telefon (WhatsApp) və ya e-poçt",
    reqContactNeeded: "Telefon (WhatsApp) və ya e-poçt yazın — seçimi ora göndərəcəyik",
    reqConsent: "Repetitor seçiminin bu e-poçta göndərilməsinə razıyam",
    reqFormat: "Harada məşğul olmaq",
    reqFormatAny: "Fərqi yoxdur",
    reqFormatTutor: "Repetitorun yanında",
    reqFormatHome: "Bizim evdə",
    reqFormatOnline: "Onlayn",
    reqOnlineOk: "Onlayn da olar",
    reqPerLesson: "dərs üçün",
    reqPerMonth: "aylıq",
    reqTeachLang: "Tədris dili",
    reqComment: "Şərh",
    reqSentTo: "Seçimi {email} ünvanına göndərdik.",
    reqSentNoEmail: "Müraciət göndərildi. Uyğun repetitorlar aşağıdadır.",
    reqMatchedTitle: "Uyğun repetitorlar",
    reqNoMatch: "Hələlik uyğun repetitor yoxdur — əl ilə seçib bir gün ərzində sizinlə əlaqə saxlayacağıq.",
    reqRateLimited: "Bu nömrədən bir gündə çox müraciət gəlib. Bizə hello@yolutap.com ünvanına yazın.",
    loadError: "Xəritəni yükləmək alınmadı. Səhifəni yeniləyin.",
    joinCta: "Repetitor və ya dərnəksiniz? Pulsuz yerləşin",
    backToMap: "← Xəritəyə",
    notFound: "Anket tapılmadı və ya xəritədən çıxarılıb.",
    separate: "Yolutap karyera hesabatlarının tövsiyələri xəritədə kimin olmasından asılı deyil.",
    mapOffNote: "Onlayn və evə gələn repetitorlar xəritədə yoxdur — «Onlayn» bölməsinə və «Evimizə gəlsin» filtrinə baxın.",
    closeCard: "Bağla",
    aboutTitle: "Haqqında",
    aboutMore: "Daha çox",
    aboutLess: "Daha az",
    links: "Keçidlər",
    photoOpen: "Şəkli açın",
    photoClose: "Bağlayın",
    openOnMap: "Xəritədə aç",
  },
  en: {
    meta: {
      title: "Tutors and clubs in Azerbaijan — Yolutap",
      description: "A map of tutors and clubs across Azerbaijan: subject, district, grade, price. Free for families.",
    },
    title: "Near home",
    h1: "Tutors and clubs in Azerbaijan",
    intro: [
      "The Yolutap map brings together tutors and clubs across Azerbaijan. Pick a subject, a district, a grade, a format and a lesson price — the map and the list show only the profiles that match. Tutors who teach online are on the Online tab.",
      "The map is free for families. You contact the tutor or club directly: the phone number appears when you tap Call. Every profile has its own page with subjects, grades, price, where lessons take place and how to get in touch.",
      "Not sure what your child should work on? Take the Yolutap test first: the report shows which subjects and directions to build on. Are you a tutor or do you run a club? Listing on the map is free.",
    ],
    introTest: "Take the test",
    introJoin: "Add yourself to the map",
    joinBannerText: "Are you a tutor or run a club? Add yourself to the map — free",
    joinBannerBtn: "Add me to the map",
    subjectPagesTitle: "Tutors by subject",
    subjectOnMap: "Open on the map",
    subjectNeighbours: "Other subjects",
    breadcrumbHub: "Tutors and clubs",
    lead: "Tutors and clubs across Azerbaijan on one map",
    layerTutors: "Tutors",
    layerClubs: "Clubs",
    tabNear: "Nearby",
    tabOnline: "Online",
    subjectAll: "All subjects",
    directionAll: "All activities",
    districtAll: "All districts",
    city: "City",
    cityAll: "All cities",
    formatAll: "Any format",
    gradeAll: "Any grade",
    agePh: "Child's age",
    priceMaxPh: "Price per lesson up to, ₼",
    priceUnknown: "Price per lesson not given — the price filter can’t check these profiles",
    trialOnly: "First lesson free",
    reset: "Reset",
    count: (n) => `Found: ${n}`,
    showMap: "Map",
    me: {
      button: "My location",
      locating: "Locating…",
      youAreHere: "You are here",
      home: "Home",
      remove: "Remove",
      sorted: "Nearest first",
      addressPh: "Address or metro",
      pinOnMap: "Mark on the map",
      pinHint: "Tap the map to place a “Home” pin. You can drag it.",
      denied: "Location access was denied. Enter an address or metro station, or mark your home on the map.",
      typeAddress: "Type the address",
      failed: "We couldn’t determine your location. Enter an address or metro station, or mark your home on the map.",
      lowAccuracy: (km) => `Your location is imprecise (about ${km}). Enter an address or metro station, or mark your home on the map.`,
      noMaps: "The map is unavailable right now — pick a district in the filter.",
    },
    showList: "List",
    perLesson: "per lesson",
    perMonth: "per month",
    nearMetro: "near metro",
    travelsTo: "Travels to",
    comesHomeAll: "Comes to our home",
    alsoTravelsTo: "Also comes to the student",
    online: "Online",
    landmark: "Landmark",
    years: "years",
    call: "Call",
    whatsapp: "WhatsApp",
    phoneError: "Couldn't get the number. Please try again.",
    more: "Details",
    trialFree: "First lesson free",
    emptyTitle: "No one in this district yet — leave a request and we'll find someone",
    notFoundTitle: "Couldn't find anyone nearby? Leave a request",
    reqLead: "Tell us who you're looking for — we'll find someone and call you back.",
    reqSubject: "Subject or activity",
    reqGrade: "Grade",
    reqAge: "Child's age",
    reqDistrict: "District",
    reqBudget: "Budget, ₼",
    reqPhone: "Phone (WhatsApp)",
    reqSend: "Leave a request",
    reqSending: "Sending…",
    reqSent: "Request sent. We'll get in touch.",
    reqError: "Couldn't send. Please try again or write to support@yolutap.com.",
    reqLeadTutor: "Tell us who you're looking for — we'll pick 3–5 tutors and email them to you within a minute.",
    reqEmail: "Email (we'll send the list)",
    reqContactTitle: "Phone (WhatsApp) or email",
    reqContactNeeded: "Add a phone (WhatsApp) or email — we'll send the matches there",
    reqConsent: "I agree to receive the tutor list at this email",
    reqFormat: "Where",
    reqFormatAny: "Doesn't matter",
    reqFormatTutor: "At the tutor's",
    reqFormatHome: "At our home",
    reqFormatOnline: "Online",
    reqOnlineOk: "Online is fine too",
    reqPerLesson: "per lesson",
    reqPerMonth: "per month",
    reqTeachLang: "Language of teaching",
    reqComment: "Comment",
    reqSentTo: "We've sent the list to {email}.",
    reqSentNoEmail: "Request sent. Matching tutors are below.",
    reqMatchedTitle: "Matching tutors",
    reqNoMatch: "No matching tutor yet — we'll pick one by hand and get in touch within a day.",
    reqRateLimited: "Too many requests from this number today. Write to us at hello@yolutap.com.",
    loadError: "Couldn't load the map. Please refresh the page.",
    joinCta: "Are you a tutor or a club? List for free",
    backToMap: "← Back to the map",
    notFound: "Profile not found or removed from the map.",
    separate: "Recommendations in Yolutap career reports don't depend on who is listed on the map.",
    mapOffNote: "Online tutors and those who come to your home aren't on the map — see the “Online” tab and the “Comes to our home” filter.",
    closeCard: "Close",
    aboutTitle: "About",
    aboutMore: "More",
    aboutLess: "Less",
    links: "Links",
    photoOpen: "Open photo",
    photoClose: "Close",
    openOnMap: "Open on the map",
  },
};
